import React, { useState, useEffect } from "react";
import Cookie from "js-cookie";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { Col, Row, Modal, Button } from "react-bootstrap";

import * as Constants from "../../../../../constants/Constants";
import * as RolePermissionConstants from "../../../../../constants/RolePermissionConstants";
import { getUserRolePermission } from "../../../../../utils/rolePermissionAccess";
import "./Addnote.css";

const AddNote = ({
  showTriggerButton,
  shouldModalVisible,
  vendorId,
  vendorDuns,
  vendorName,
  shouldModalVisibleHandler,
  addNote,
  merchandiseType,
}) => {
  const [state, setState] = useState({
    noteDetails: {
      vendorProfileId: vendorId,
      duns: vendorDuns,
      noteType: "",
      updatedBy: Cookie.get("email"),
      updatedByFullName: Cookie.get("userName"),
      customNotes: "",
      createdDate: new Date(),
    },
    showModal: showTriggerButton ? false : shouldModalVisible,
    noteTypeList: Constants.NOTES_TYPE,
    multiSelectValue: [],
    numberofchars: 0,
    totalChar: 400,
    errorMessage: "",
    isValid: false,
  });

  useEffect(() => {
    noteTypeDropdown(null);
  }, []);

  const openModelHandler = () => {
    setState((prevState) => ({ ...prevState, showModal: true }));
  };

  const closeModalHandler = () => {
    let noteDetailsTemp = { ...state.noteDetails };
    Object.keys(noteDetailsTemp).forEach((key) => {
      if (key === "createdDate") {
        noteDetailsTemp[key] = new Date();
      } else if (
        key === "duns" ||
        key === "vendorProfileId" ||
        key === "updatedBy" ||
        key === "updatedByFullName"
      ) {
        noteDetailsTemp[key] = noteDetailsTemp[key];
      } else {
        noteDetailsTemp[key] = null;
      }
    });
    noteTypeDropdown(null);
    setState((prevState) => ({
      ...prevState,
      showModal: false,
      noteDetails: noteDetailsTemp,
      errorMessage: "",
      numberofchars: 0,
    }));
    if (!showTriggerButton) {
      shouldModalVisibleHandler();
    }
  };

  const handleChange = (value, key) => {
    let data = {};
    let customeMess = false;
    if (key === "customNotes") {
      customeMess = true;
    } else {
      customeMess = false;
    }
    if (customeMess) {
      setState((prevState) => {
        data = { ...prevState.noteDetails };
        data[key] = value;
        let numberOfCharAdded = 0;
        if (
          value.length > prevState.numberofchars &&
          value.length - prevState.numberofchars == 1
        ) {
          numberOfCharAdded = prevState.numberofchars + 1;
        } else if (
          value.length > prevState.numberofchars &&
          value.length - prevState.numberofchars > 1
        ) {
          numberOfCharAdded = value.length;
        } else if (
          value.length < prevState.numberofchars &&
          prevState.numberofchars - value.length == 1
        ) {
          numberOfCharAdded = prevState.numberofchars - 1;
        } else if (
          value.length < prevState.numberofchars &&
          prevState.numberofchars - value.length > 1
        ) {
          numberOfCharAdded = value.length;
        } else {
          numberOfCharAdded = prevState.numberofchars;
        }

        return {
          ...prevState,
          noteDetails: data,
          numberofchars: numberOfCharAdded,
          errorMessage: "",
        };
      });
    } else {
      setState((prevState) => {
        data = { ...prevState.noteDetails };
        data[key] = value;
        return {
          ...prevState,
          noteDetails: data,
          errorMessage: "",
        };
      });
    }
  };

  const setValue = (event) => {
    noteTypeDropdown(event.target.value);
    handleChange(event.target.value, "noteType");
  };

  const validate = (noteDetail) => {
    let isValid = true;
    let errMessage = "";

    Object.keys(noteDetail).forEach((key) => {
      if (typeof noteDetail[key] === "object" && isValid && key !== "duns") {
        isValid = noteDetail[key] == null ? false : true;
      } else if (isValid && key !== "duns") {
        isValid = noteDetail[key].length === 0 ? false : true;
      }
    });
    errMessage = isValid ? "" : "All fields are mandatory";

    setState((prevState) => ({ ...prevState, errorMessage: errMessage }));

    return isValid;
  };

  const noteTypeDropdown = (element) => {
    let noteTypesValue = Object.keys(state.noteTypeList).map((key, i) => {
      if (
        (state?.noteTypeList[key] === Constants.NOTES_TYPE.setupDvnSuffixes &&
          merchandiseType === Constants.VOB_MERCHANDISE_TYPE_CONSIGNMENT) ||
        state?.noteTypeList[key] !== Constants.NOTES_TYPE.setupDvnSuffixes
      ) {
        return (
          <label htmlFor={key} key={`noteType-${key}`}>
            <input
              data-testid={`addnote-noteCheckBox-${i}`}
              type="checkbox"
              id={key}
              value={key}
              checked={element != null && element === key ? true : false}
              onChange={(e) => setValue(e)}
            />
            {state.noteTypeList[key]}
          </label>
        );
      }
    });
    setState((prevState) => ({
      ...prevState,
      noteTypes: noteTypesValue,
      errorMessage: "",
    }));
  };

  const addNoteDetails = () => {
    addNote(state.noteDetails);
    closeModalHandler();
  };

  return (
    <>
      {showTriggerButton && (
        <Button
          data-testid="addnote-showmodal-button"
          style={{ margin: "0 15px" }}
          size="sm"
          variant="outline-dark"
          onClick={() => {
            openModelHandler();
          }}
          disabled={
            !(
              getUserRolePermission(
                RolePermissionConstants.VENDORPLATFORM_NOTES_NOTELIST,
                RolePermissionConstants.VMP_ADDNOTE
              ) === RolePermissionConstants.EDIT
            )
          }
        >
          + Add Note
        </Button>
      )}
      {state.showModal && (
        <Modal
          show={true}
          onHide={closeModalHandler}
          contentClassName="addNoteModal"
        >
          <Modal.Header closeButton>
            <Modal.Title data-testid="addnote-modalTitle">
              {`Add Note - ${vendorName || "Vendor name not available"}`}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="addnote-modalBody">
            {state.errorMessage && (
              <p className="errMessage">{state.errorMessage}</p>
            )}
            <Row>
              <Col xs={12}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Date"
                    format="MM/dd/yyyy"
                    value={state.noteDetails.createdDate}
                    onChange={(value) => {
                      handleChange(value, "createdDate");
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    maxDate={new Date()}
                  />
                </MuiPickersUtilsProvider>
              </Col>
              <Col md={4}>
                <FormControl variant="outlined">
                  <div className="multiselect">
                    <div id="checkboxes">{state.noteTypes}</div>
                  </div>
                </FormControl>
              </Col>
              <Col
                xs={8}
                style={{ display: "flex", flexDirection: "column-reverse" }}
              >
                <TextField
                  data-testid="addnote-noteTextBox"
                  id="notes"
                  label=""
                  value={state.noteDetails.customNotes}
                  helperText={`${state.totalChar -
                    state.numberofchars} characters remaining.`}
                  onChange={(event) => {
                    handleChange(event.target.value, "customNotes");
                  }}
                  multiline
                  fullWidth={true}
                  inputProps={{ maxLength: 400 }}
                />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ width: "100%" }}>
              <Button
                className="button-primary-md float-right"
                onClick={() => {
                  validate(state.noteDetails) ? addNoteDetails() : null;
                }}
                disabled={
                  !state.noteDetails.customNotes || !state.noteDetails.noteType
                }
              >
                Add
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default AddNote;
